export interface DuoColorIconProps {
  className?: string
  color2?: string
  color1?: string
}

export const CalendarIcon = ({
  color1 = '#000',
  color2 = '#fff',
  ...props
}: DuoColorIconProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={35}
    height={35}
    fill='none'
    {...props}
  >
    <title>Kalender</title>
    <g
      stroke={color1}
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.75}
      clipPath='url(#a)'
    >
      <path
        fill={color2}
        d='M6.167 10.516A2.833 2.833 0 0 1 9 7.683h17a2.833 2.833 0 0 1 2.833 2.833v17A2.833 2.833 0 0 1 26 30.349H9a2.833 2.833 0 0 1-2.833-2.833v-17Z'
      />
      <path d='M23.166 4.85v5.666M11.834 4.85v5.666M6.167 16.183h22.666M10.416 20.433h.019M14.68 20.433h.008M18.93 20.433h.008M23.188 20.433h.008M18.938 24.683h.008M10.43 24.683h.008M14.68 24.683h.008' />
    </g>
    <defs>
      <clipPath id='a'>
        <path fill={color2} d='M.5.6h34v34H.5z' />
      </clipPath>
    </defs>
  </svg>
)

export const GoogleIcon = ({
  color1 = '#000',
  color2 = '#fff',
  ...props
}: DuoColorIconProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={36}
    height={35}
    fill='none'
    {...props}
  >
    <title>Google Logo</title>
    <path
      fill={color2}
      stroke={color1}
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.75}
      d='M31.211 16.38a12.464 12.464 0 0 1-2.04 8.368c-1.658 2.476-4.149 4.316-7.047 5.206-2.899.89-6.026.775-8.847-.325-2.82-1.1-5.161-3.118-6.621-5.708a12.433 12.433 0 0 1-1.385-8.494c.565-2.902 2.15-5.523 4.483-7.416a13.358 13.358 0 0 1 8.31-2.964 13.37 13.37 0 0 1 8.358 2.837l-3.872 3.389a8.197 8.197 0 0 0-4.677-1.26 8.17 8.17 0 0 0-4.57 1.59 7.797 7.797 0 0 0-2.787 3.86 7.58 7.58 0 0 0 .014 4.716 7.8 7.8 0 0 0 2.812 3.843 8.172 8.172 0 0 0 4.58 1.565c1.655.049 3.287-.401 4.669-1.288a7.841 7.841 0 0 0 3.05-3.67h-6.016v-4.25H31.21Z'
    />
  </svg>
)

export const ErpSoftwareIcon = ({
  color1 = '#000',
  color2 = '#fff',
  ...props
}: DuoColorIconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={34}
      height={34}
      fill='none'
      {...props}
    >
      <title>Branchen-Software</title>
      <g
        stroke={color1}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.75}
      >
        <path
          fill={color2}
          d='M29.75 17a12.75 12.75 0 1 0-14.121 12.676M5.1 12.75h23.8M5.1 21.25h9.067'
        />
        <path d='M16.292 4.25a24.084 24.084 0 0 0-2.672 19.553M17.709 4.25a24.059 24.059 0 0 1 3.61 11.348' />
        <path
          fill={color2}
          d='m25.216 29.491-3.076 1.612a.554.554 0 0 1-.805-.58l.588-3.416-2.49-2.418a.55.55 0 0 1 .308-.942l3.44-.5 1.538-3.106a.555.555 0 0 1 .995 0l1.538 3.107 3.44.498a.552.552 0 0 1 .307.943l-2.489 2.418.587 3.414a.553.553 0 0 1-.803.582l-3.078-1.612Z'
        />
      </g>
    </svg>
  )
}

export const PhoneIcon = ({
  color1 = '#000',
  color2 = '#fff',
  ...props
}: DuoColorIconProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={34}
    height={34}
    fill='none'
    {...props}
  >
    <title>Telefon</title>
    <path
      fill={color2}
      stroke={color1}
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.75}
      d='M7.083 5.667h5.667l2.833 7.083-3.541 2.125a15.583 15.583 0 0 0 7.083 7.084l2.125-3.542 7.083 2.833v5.667A2.834 2.834 0 0 1 25.5 29.75 22.667 22.667 0 0 1 4.25 8.5a2.833 2.833 0 0 1 2.833-2.833Z'
    />
  </svg>
)

/**
 * This is an edited version of the "Phosphor icon" - "identification-card"
 * https://phosphoricons.com/?q=%22identi%22
 *
 * The original icon has no background color.
 * */
export const CustomerIcon = ({
  color1 = '#000',
  color2 = '#fff',
  ...props
}: DuoColorIconProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={34}
    height={34}
    viewBox='0 0 256 256'
    {...props}
  >
    <title>Kunden-Kartei</title>
    <path
      d='M 232 56 L 232 200 C 232 208.837 224.837 216 216 216 L 40 216 C 31.164 216 24 208.837 24 200 L 24 56 C 24 47.164 31.164 40 40 40 L 216 40 C 224.837 40 232 47.164 232 56 Z'
      fill={color2}
    />
    <path
      d='M200,112a8,8,0,0,1-8,8H152a8,8,0,0,1,0-16h40A8,8,0,0,1,200,112Zm-8,24H152a8,8,0,0,0,0,16h40a8,8,0,0,0,0-16Zm40-80V200a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56ZM216,200V56H40V200H216Zm-80.26-34a8,8,0,1,1-15.5,4c-2.63-10.26-13.06-18-24.25-18s-21.61,7.74-24.25,18a8,8,0,1,1-15.5-4,39.84,39.84,0,0,1,17.19-23.34,32,32,0,1,1,45.12,0A39.76,39.76,0,0,1,135.75,166ZM96,136a16,16,0,1,0-16-16A16,16,0,0,0,96,136Z'
      fill={color1}
    />
  </svg>
)

export const PageBuilderIcon = ({
  color1 = '#000',
  color2 = '#fff',
  ...props
}: DuoColorIconProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={35}
    height={35}
    fill='none'
    {...props}
  >
    <title>Webseite</title>
    <g
      stroke={color1}
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
    >
      <path
        fill={color2}
        d='M5.083 10.11a2.833 2.833 0 0 1 2.834-2.833H27.75a2.833 2.833 0 0 1 2.834 2.834v14.166a2.833 2.833 0 0 1-2.834 2.834H7.917a2.833 2.833 0 0 1-2.833-2.834V10.111ZM9.334 11.527h.013M13.584 11.527h.013'
      />
    </g>
  </svg>
)

export const CustomSupport = ({
  color1 = '#000',
  color2 = '#fff',
  ...props
}: DuoColorIconProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={35}
    height={35}
    viewBox='0 0 24 24'
    fill='none'
    {...props}
  >
    <title>Vertragsverwaltung</title>
    <g
      stroke={color1}
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      clipPath='url(#a)'
    >
      <path
        fill={color2}
        d='M16 6h3a1 1 0 0 1 1 1v11a2 2 0 0 1 -4 0v-13a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1v12a3 3 0 0 0 3 3h11'
      />
      <path d='M16 6h3a1 1 0 0 1 1 1v11a2 2 0 0 1 -4 0v-13a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1v12a3 3 0 0 0 3 3h11' />
      <path d='M8 8l4 0' />
      <path d='M8 12l4 0' />
      <path d='M8 16l4 0' />
    </g>
  </svg>
)

export const PlusIcon = ({ color1 = '#000', ...props }: DuoColorIconProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={24}
    height={24}
    viewBox='0 0 24 24'
    fill='none'
    {...props}
  >
    <title>Vertragsverwaltung</title>
    <g
      stroke={color1}
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      clipPath='url(#a)'
    >
      <path d='M12 5l0 14' />
      <path d='M5 12l14 0' />
    </g>
  </svg>
)

export const DownloadIcon = ({
  color1 = '#000',
  ...props
}: DuoColorIconProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={18}
    height={19}
    viewBox='0 0 18 19'
    fill='none'
    {...props}
  >
    <title>herunterladen</title>
    <path
      d='M1 14V16C1 16.5304 1.21071 17.0391 1.58579 17.4142C1.96086 17.7893 2.46957 18 3 18H15C15.5304 18 16.0391 17.7893 16.4142 17.4142C16.7893 17.0391 17 16.5304 17 16V14M4 8L9 13M9 13L14 8M9 13V1'
      stroke={color1}
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
